// extracted by mini-css-extract-plugin
module.exports = {"companyMedia":"event_companyMedia__b0oOH"};